import styled from 'styled-components';
const FlexRow = styled.div.withConfig({
  displayName: "FlexRow",
  componentId: "sc-1mkifc8-0"
})(["display:flex;flex-direction:row;width:100%;"]);
export default FlexRow;